import { render, staticRenderFns } from "./bindlist.vue?vue&type=template&id=4df0b79b&scoped=true"
import script from "./bindlist.vue?vue&type=script&lang=js"
export * from "./bindlist.vue?vue&type=script&lang=js"
import style0 from "./bindlist.vue?vue&type=style&index=0&id=4df0b79b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df0b79b",
  null
  
)

export default component.exports